import React, { PropTypes } from 'react';
import { Link, hashHistory } from 'react-router';
import { Modal, Spin, Input, message, Select } from 'antd';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import ArchiveChooseTemplateModal from '../share/ArchiveChooseTemplateModal';

const Option = Select.Option;


export default class ArchiveContentSettingClassPage extends React.Component {

  constructor(props) {
    super(props);
    let currentSemester = SharedTools.getCurrentSemester();
    let semester = localStorage.getItem("semester") ? localStorage.getItem("semester") : (props.location.query.semester ? props.location.query.semester : currentSemester);
    localStorage.removeItem("semester");
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      archive: {},
      pageContent: [],
      backupPageContent: [],
      changePage: {},
      deletePage: {},
      showModal: false,
      showTemplateModal: false,
      choosedTemplate: {},
      dragPageIndex: 0,
      loading: true,
      semesters: [],
      currentSemester,
      semester,
    };
    // bind this
    this.onCurrentRoleChange = this.onCurrentRoleChange.bind(this);
    this.changeTheme = this.changeTheme.bind(this);
    this.deleteTheme = this.deleteTheme.bind(this);
    this.goChooseThemePage = this.goChooseThemePage.bind(this);
    this.goDeletePage = this.goDeletePage.bind(this);
    this.showTemplateModal = this.showTemplateModal.bind(this);
    this.hideTemplateModal = this.hideTemplateModal.bind(this);
    this.onPageDragStart = this.onPageDragStart.bind(this);
    this.onPageDragEnd = this.onPageDragEnd.bind(this);
    this.onPageDragEnter = this.onPageDragEnter.bind(this);
    this.onPageDragLeave = this.onPageDragLeave.bind(this);
    this.onPageDragOver = this.onPageDragOver.bind(this);
    this.onPageDrop = this.onPageDrop.bind(this);

    // 修改模版名称
    this.changeEditInput = this.changeEditInput.bind(this);
    this.editTheme = this.editTheme.bind(this);
    this.okEditTheme = this.okEditTheme.bind(this);

    // 切换学期
    this.selectSemester = this.selectSemester.bind(this)
  }

  componentWillMount() {
    DataService.getClassById(this.props.params.classId).then(res => {
      let semesters = SharedTools.getAllSemesters(this.state.currentSemester, SharedTools.getCurrentSemester(res.created_at), res.archive_semester_count);
      
      // 设置默认学期为该年份第一个学期
      let currentSemester = this.state.semester, semester;
      if (res.archive_semester_count == 1) {
        semester = String(currentSemester).substring(0, 4) + '1';
      } else {
        semester = currentSemester;
      }
      this.setState({
        semesters,
        semester
      }, () => {
        this.getArchives(this.state.semester);
      })
      
    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
      })
    })
    
  }

  componentDidMount(){
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
  }

  onCurrentRoleChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole()
    });
  }

  getArchives(semester) {
    this.setState({
      loading: true,
    })
    DataService.getArchives(this.props.params.classId, semester).then(res => {
      let archiveType = res.quality == 'hardback' ? 1 : 0;
      let pageContent = Array(res.page_count + 1).fill(false);
      if (res.pages) {
        res.pages.map(page => {
          if (page.page_type === 'front_cover') {
            pageContent[0] = page;
          } else if (page.page_type == 'inside') {
            pageContent[page.page_number] = page;
          }
        })
      }
      if (archiveType == 0) {
        pageContent.splice(1, 0, false);
      }
      this.setState({
        pageContent: pageContent,
        backupPageContent: SharedTools.cloneObject(pageContent),
        archive: res,
        loading: false
      })
    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
        archive: {},
        pageContent: [],
      })
    })
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.getArchives(this.state.semester)
      })
    }
  }

  changeTheme(e) {
    e.stopPropagation();
    let pageContent = this.state.pageContent;
    let {position, index, number} = e.currentTarget.dataset;

    let showModal = false;
    let changePage = {
      position: position,
      index: index,
      number: number
    };

    let page = pageContent.find(p => p.page_type == "inside" && p.page_number == number);
    if (page && page.complete_count !== 0) {
      showModal = true;
      changePage.complete_count = page.complete_count;

      this.setState({
        changePage: changePage,
        showModal: showModal
      })
    } else {
      hashHistory.push(`archive/content-setting/schools/${this.props.params.schoolId}/classes/${this.props.params.classId}/choose-template?pageNumber=${changePage.number}&archiveId=${this.state.archive.id}`);
      localStorage.setItem("semester", this.state.semester)
    }
  }

  deleteTheme(e) {
    e.stopPropagation();
    let {pid} = e.currentTarget.dataset;
    let page = this.state.pageContent.find(p => p.page_type == "inside" && p.id == pid);
    if (page && page.complete_count >= 0) {
      this.setState({
        deletePage: {
          id: page.id,
          complete_count: page.complete_count
        },
        showModal: true
      })
    }
  }

  editTheme(e) {
    e.stopPropagation();
    let { pid } = e.currentTarget.dataset;
    let page = this.state.pageContent.find(p => p.id == pid);
    if (page.template.t_type == "album" && !page.album_id) {
      message.info("请先进入页面指定相册后再更改名称", 3)
      return
    }

    if (page && page.complete_count >= 0) {
      this.setState({
        editPage: {
          id: page.id,
          comment: ''
        },
        showEditModal: true
      })
    }
  }


  changeEditInput(e) {
    let editPage = this.state.editPage;
    editPage.comment = e.target.value;
    this.setState({
      editPage
    })
  }

  okEditTheme() {
    let { id, comment } = this.state.editPage;
    let page = this.state.pageContent.find(p => p.page_type == "inside" && p.id == id);
    if (comment) {
      if (page.template.t_type == 'album') {
        DataService.batchChangeClassPageContentAlbumTitle(this.props.params.classId, id, comment).then((res) => {
          this.getArchives(this.state.semester);
          this.setState({
            editPage: {},
            showEditModal: false,
            // pageContent: this.state.pageContent
          })
        }).catch((error) => {
          message.error('修改相册名称失败，请稍后重试');
        })
      } else {
        DataService.createComment(id, comment).then(() => {
          let page = this.state.pageContent.find(p => p.id == id);
          page.comment = comment;
          this.setState({
            editPage: {},
            showEditModal: false,
            pageContent: this.state.pageContent
          })
        }).catch((error) => {
          if (error && error.errorMessage && error.errorMessage.errors[0].code == 11) {
            message.error('模版名称不能为空!');
          } else {
            message.error('模版名称修改失败，请重试!');
          }
        })
      }
    } else {
      message.error('模版名称不能为空!');
    }
  }

  goChooseThemePage() {
    this.setState({
      showModal: false,
      changePage: {}
    })
    hashHistory.push(`archive/content-setting/schools/${this.props.params.schoolId}/classes/${this.props.params.classId}/choose-template?pageNumber=${this.state.changePage.number}&archiveId=${this.state.archive.id}`);
  }

  goDeletePage() {
    let pageId = this.state.deletePage.id;
    DataService.removeTheme(pageId).then(() => {
      let index = this.state.pageContent.findIndex(p => p.id == pageId);
      this.state.pageContent.splice(index, 1, false);
      this.setState({
        pageContent: this.state.pageContent,
        showModal: false,
        deletePage: {}
      })
    })
  }

  showTemplateModal(template, author) {
    this.setState({
      showTemplateModal: true,
      choosedTemplate: template,
      choosedTemplateAuthor: author
    })
  }

  hideTemplateModal() {
    this.setState({
      showTemplateModal: false,
      choosedTemplate: {},
      choosedTemplateAuthor: '',
    })
  }

  onPageDragStart(e) {
    let {pindex} = e.currentTarget.dataset;
    this.setState({
      dragPageIndex: pindex,
      backupPageContent: SharedTools.cloneObject(this.state.pageContent)
    })
  }

  onPageDragEnd(e) {
    let {pindex} = e.currentTarget.dataset;

    this.setState({
      dragPageIndex: null,
    })
  }

  onPageDragEnter(e) {
    let {pindex} = e.currentTarget.dataset;

    if (!this.state.dragPageIndex || !pindex) {
      return
    }

    let dragPageIndex = this.state.dragPageIndex
    let overPageIndex = pindex

    this.state.pageContent = SharedTools.cloneObject(this.state.backupPageContent)
    let dragPage = this.state.pageContent[dragPageIndex]
    let overPage = this.state.pageContent[overPageIndex]

    // Deprecated: insert source element to target position
    // if (Number(dragPageIndex) > Number(overPageIndex)) {
    //   this.state.pageContent.splice(dragPageIndex, 1)
    //   this.state.pageContent.splice(overPageIndex, 0, dragPage)
    // } else if (Number(dragPageIndex) < Number(overPageIndex)) {
    //   this.state.pageContent.splice(Number(overPageIndex) + 1, 0, dragPage)
    //   this.state.pageContent.splice(dragPageIndex, 1)
    // }

    // swap source element and the element at target position
    if (overPage) {
      overPage.page_number = this.state.archive.quality == 'hardback' ? dragPageIndex : dragPageIndex - 1;
    }
    if (dragPage) {
      dragPage.page_number = this.state.archive.quality == 'hardback' ? overPageIndex : overPageIndex - 1;
    }
    
    this.state.pageContent[dragPageIndex] = overPage
    this.state.pageContent[overPageIndex] = dragPage


    this.setState({
      pageContent: this.state.pageContent,
    })
  }

  onPageDragLeave(e) {
    let {pindex} = e.currentTarget.dataset;
    this.state.pageContent = SharedTools.cloneObject(this.state.backupPageContent)
    this.setState({
      pageContent: this.state.pageContent,
    })
  }

  onPageDragOver(e) {
    e.preventDefault();
  }

  onPageDrop(e) {
    let {pindex} = e.currentTarget.dataset;

    let pagesOrder = {}
    let somePageChanged = this.state.pageContent.map((p, index) => {
      if (p && p.page_type == "inside") {
        // 构造数据时除去封面，page 在 pageContent 的 index 和 page.page_number 一致（硬壳有偏移）
        // 拖拽调整顺序后新的顺序信息保存在 page index，没有改动 page.page_number
        pagesOrder[p.id] = index - 1 + (this.state.archive.quality == 'hardback' ? 1 : 0);
        return p.id == (this.state.backupPageContent[index] || {}).id
      }
      return true
    })
    if (!somePageChanged.reduce((r, c) => r && c)) {
      DataService.reorderPages(this.state.archive.id, JSON.stringify(pagesOrder))
    }
  }

  _insidePages() {
    let archiveType = this.state.archive.quality == 'hardback' ? 1 : 0;
    let pages = [];
    if (this.state.pageContent.length <= 0) {
      return;
    }
    pages.push(
      <div className="page-detail-box front-cover-box" key='page-0' onClick={this.showTemplateModal.bind(this, this.state.pageContent[0].template, this.state.pageContent[0].author_type)}>
        <div className="page-right draggable front-cover">
          <div className="page-number">封面</div>
          <div className="img-cover" style={{"background": `url(${this.state.pageContent[0].template.icon_url})`, backgroundSize: '4.5rem 4.5rem'}}></div>
          <div className="title">{this.state.pageContent[0].template.title}</div>
          {(this.state.pageContent[0] && this.state.pageContent[0].template && !this.state.pageContent[0].show_answer) ? <div className="edit-btn" onClick={this.editTheme} data-pid={this.state.pageContent[0].id}>修改模版名称</div> : ''}
        </div>
      </div>
    )
    for (let i = 1; i < this.state.pageContent.length; i += 2) {
      let index = (i + 1) / 2;
      let leftPage  = this.state.pageContent[i];
      let rightPage = this.state.pageContent[i + 1];
      pages.push(
        <PageDetailBox showTemplateModal={this.showTemplateModal} key={`page-${index}-${leftPage && leftPage.id}-${rightPage && rightPage.id}`}
                       index={index} left={leftPage} right={rightPage}
                       leftNumber={i - 1 + archiveType}
                       archiveType={archiveType}
                       pageCount={this.state.archive.page_count} changeTheme={this.changeTheme} deleteTheme={this.deleteTheme} editTheme={this.editTheme}
                       onPageDragStart={this.onPageDragStart} onPageDragEnd={this.onPageDragEnd}
                       onPageDragEnter={this.onPageDragEnter} onPageDragLeave={this.onPageDragLeave}
                       onPageDrop={this.onPageDrop} onPageDragOver={this.onPageDragOver}
      />)
    }
    return <div>{pages}</div>
  }

  _changeThemeModal() {
    let modalData = {};
    if (this.state.changePage.number) {
      modalData.title = "更换模版";
      modalData.text = `已有${this.state.changePage.complete_count}位宝贝完成了此模版，更换后已填写的内容将清除，确认更换模版吗？`;
      modalData.onBtnClick = this.goChooseThemePage;
      modalData.btnText = "去更换";
    } else if (this.state.deletePage.id) {
      modalData.title = "删除模版";
      modalData.onBtnClick = this.goDeletePage;
      modalData.btnText = "确认删除"
      if (this.state.deletePage.complete_count > 0) {
        modalData.text = `已有${this.state.deletePage.complete_count}位宝贝完成了此模版，删除后已填写的内容将清除，确认删除模版吗？`;
      } else {
        modalData.text = "确认删除模版吗？";
      }
    }

    return (
      <Modal
        className="archive-content-setting-class-page-change-theme-modal"
        title={null}
        visible={this.state.showModal}
        footer={null}
        onCancel={() => {this.setState({showModal: false, changePage: {}, deletePage: {}})}}
      >
        <div className="title">{modalData.title}</div>
        <div className="text">{modalData.text}</div>
        <div className="btn" onClick={modalData.onBtnClick}>{modalData.btnText}</div>
      </Modal>
    )
  }

  _editThemeModal() {
    return (
      <Modal
        className="archive-content-setting-class-page-change-theme-modal"
        title="更换模版名称"
        visible={this.state.showEditModal}
        footer={null}
        onCancel={() => { this.setState({ showEditModal: false, editPage: {} }) }}
      >
        <label>模版名称更换为: </label>
        <Input placeholder="请输入模版名称" style={{ marginLeft: 20, width: '50%' }} onChange={this.changeEditInput} value={this.state.editPage ? this.state.editPage.comment : ''}></Input>
        <div className="btn" onClick={this.okEditTheme}>确认</div>
      </Modal>
    )
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  render() {
    if ((!this.state.archive.id || !this.state.pageContent[0]) && !this.state.loading) {
      return (
        <div className="archive-content-setting-class-page">
          {this._selectSemesterBox()}
          <div className="no-archive">找不到档案数据，请联系管理员</div>
        </div>
      )
    } else {
      return (
        <div className="archive-content-setting-class-page">
          {this._selectSemesterBox()}
          <Spin spinning={this.state.loading} size="large">
            <div className="tips-reorder">按住档案内页拖动可调整顺序</div>
            {this._insidePages()}
            {this._changeThemeModal()}
            {this._editThemeModal()}
            <ArchiveChooseTemplateModal author={this.state.choosedTemplateAuthor} template={this.state.choosedTemplate} showModal={this.state.showTemplateModal} hideModal={this.hideTemplateModal} isChoose={false}/>
          </Spin>
        </div>
      )
    }
  }
}

class PageDetailBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      left: props.left,
      right: props.right,
      leftNumber: props.leftNumber,
      rightNumber: Number(props.leftNumber) + 1,
      pindex: props.leftNumber + 1 - props.archiveType,
      pageCount: props.pageCount,
    }

    this.showTemplateModal = this.showTemplateModal.bind(this);
    this.onPageDragStart = this.props.onPageDragStart;
    this.onPageDragEnd = this.props.onPageDragEnd;
    this.onPageDragEnter = this.props.onPageDragEnter;
    this.onPageDragLeave = this.props.onPageDragLeave;
    this.onPageDragOver = this.props.onPageDragOver;
    this.onPageDrop = this.props.onPageDrop;
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      left: newProps.left,
      right: newProps.right,
      leftNumber: newProps.leftNumber,
      rightNumber: Number(newProps.leftNumber) + 1,
      pindex: newProps.leftNumber + 1 - newProps.archiveType,
      pageCount: newProps.pageCount,
    })
  }

  showTemplateModal(e) {
    let {position, author} = e.currentTarget.dataset;

    this.props.showTemplateModal(this.state[position].template, author);
  }


  render() {
    let {left, right, leftNumber, rightNumber, pageCount} = this.state;
    return (
      <div className="page-detail-box">
        {left && (
          <div className="page-left draggable" data-position="left" data-author={left.author_type} onClick={this.showTemplateModal} draggable="true" data-pindex={this.state.pindex} onDragStart={this.onPageDragStart} onDragEnd={this.onPageDragEnd} onDragEnter={this.onPageDragEnter} onDragLeave={this.onPageDragLeave} onDragOver={this.onPageDragOver} onDrop={this.onPageDrop}>
            <div className="page-number">
              <span className="number">{leftNumber}</span>页
            </div>
            <div className="img-cover" style={{"background": `url(${left.template.icon_url}) no-repeat`, backgroundSize: '4.5rem 4.5rem'}}></div>
            <div className="title">{left.template.title}</div>
            <div className="title">{left.comment}</div>
            {(left && left.template && left.template.show_answer) ? <div className="title">{left.template.t_type == 'album' ? (left.album_title ? left.album_title : '') : left.theme_title}</div> : ''}
            {left.template.need_review && <div className="review">需审核</div>}
            {(left && left.template && !(left.template.t_type == "no_render" && left.template.show_answer)) ? <div className="edit-btn" onClick={this.props.editTheme} data-pid={left.id}>修改模版名称</div> : ''}
            <div className="change-btn" onClick={this.props.changeTheme} data-number={leftNumber} data-position="left" data-index={this.props.index}>更换</div>
            <div className="delete-btn" onClick={this.props.deleteTheme} data-pid={left.id}>删除</div>
          </div>
        )}
        {!left && (leftNumber !== 0) && (
          <div className="page-left empty" draggable="true" data-pindex={this.state.pindex} onDragStart={this.onPageDragStart} onDragEnd={this.onPageDragEnd} onDragEnter={this.onPageDragEnter} onDragLeave={this.onPageDragLeave} onDragOver={this.onPageDragOver} onDrop={this.onPageDrop}>
            <div className="add-page" onClick={this.props.changeTheme} data-number={leftNumber} data-position="left" data-index={this.props.index}>+</div>
            <div className="page-number empty">第{leftNumber}页</div>
          </div>
        )}
        {!left && (leftNumber === 0) && (
          <div className="page-left first-page">
            <div>首页</div>
            <div>空白</div>
          </div>
        )}

        {((right && left) || (!right && (rightNumber === pageCount + 1)) || (!left && (leftNumber === 0))) && <div className="divide-line"></div>}

        {right && (
          <div className="page-right draggable" data-position="right" data-author={right.author_type} onClick={this.showTemplateModal} draggable="true" data-pindex={this.state.pindex + 1} onDragStart={this.onPageDragStart} onDragEnd={this.onPageDragEnd} onDragEnter={this.onPageDragEnter} onDragLeave={this.onPageDragLeave} onDragOver={this.onPageDragOver} onDrop={this.onPageDrop}>
            <div className="page-number">
              <span className="number">{rightNumber}</span>页
            </div>
            <div className="img-cover" style={{"background": `url(${right.template.icon_url})`, backgroundSize: '4.5rem 4.5rem'}}></div>
            <div className="title">{right.template.title}</div>
            <div className="title">{right.comment}</div>
            {(right && right.template && right.template.show_answer) ? <div className="title">{right.template.t_type == 'album' ? (right.album_title ? right.album_title : '') : right.theme_title}</div> : ''}
            {right.template.need_review && <div className="review">需审核</div>}
            {(right && right.template && !(right.template.t_type == "no_render" && right.template.show_answer)) ? <div className="edit-btn" onClick={this.props.editTheme} data-pid={right.id}>修改模版名称</div> : ''}
            <div className="change-btn" onClick={this.props.changeTheme} data-number={rightNumber} data-position="right" data-index={this.props.index}>更换</div>
            <div className="delete-btn" onClick={this.props.deleteTheme} data-pid={right.id}>删除</div>
          </div>
        )}
        {!right && (rightNumber !== pageCount + 1) && (
          <div className="page-right empty" draggable="true" data-pindex={this.state.pindex + 1} onDragStart={this.onPageDragStart} onDragEnd={this.onPageDragEnd} onDragEnter={this.onPageDragEnter} onDragLeave={this.onPageDragLeave} onDragOver={this.onPageDragOver} onDrop={this.onPageDrop}>
            <div className="add-page" onClick={this.props.changeTheme} data-number={rightNumber} data-position="right" data-index={this.props.index}>+</div>
            <div className="page-number empty">第{rightNumber}页</div>
          </div>
        )}
        {!right && (rightNumber === pageCount + 1) && (
          <div className="page-right last-page">
            <div>尾页</div>
            <div>空白</div>
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveContentSettingClassPage.jsx